import { useContext } from 'react';

import { TimeseriesChartSelectContext } from '../context/TimeseriesChartSelect.context.js';

export const useTimeseriesSelect = () =>
  useContext(TimeseriesChartSelectContext);
